//dependencias
import React, { Component } from 'react';

//componentes
import MedicosAction from './medicos'

class Espera extends Component {

    render(){
        return(
            <div>
                <MedicosAction />
            </div>
        );
    }

}
export default Espera;